module.exports = __webpack_public_path__ + "media/images/hitfun/welcome.socials.odnoklassniki-e9b3ead155b0c8f598e79617047568e9.svg";